import { PRODUCTS_DISABLE_RENEW_BUTTON } from "common";

export const productToDisableRenewButton = (productAnalyze, modalityAnalyze, risks) =>
  PRODUCTS_DISABLE_RENEW_BUTTON.some(({ product, modality, verifyRisks }) => {
    const sameProduct = product == productAnalyze;
    const isModalityInclude = modality.includes(!modalityAnalyze ? 0 : +modalityAnalyze);
    const needVerifyRisks = verifyRisks && risks ? risks > 10 : true;
    return sameProduct && isModalityInclude && needVerifyRisks;
  });
